"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./GlobalStyles.css");
// import '@idp/styles/styles/standard-fonts.scss';
// import '@idp/styles/styles/standard-css-2-reset.scss';
require("@idp/styles/styles/standard-css-3-grid.scss");
// import '@idp/styles/styles/standard-css-buttons-links.scss';
// import '@idp/styles/styles/standard-css-typography.scss';
// import '@idp/styles/styles/standard-css-color-palette.scss';
// import '@idp/styles/styles/standard-css-utilities.scss';
var GlobalStyles = /** @class */ (function (_super) {
    __extends(GlobalStyles, _super);
    function GlobalStyles() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalStyles.prototype.render = function () {
        return null;
    };
    return GlobalStyles;
}(React.Component));
exports.default = GlobalStyles;
//# sourceMappingURL=GlobalStyles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/GlobalStyles/GlobalStyles.js
// module id = 1147
// module chunks = 8